// Iter 905 (Kamel) — 📤 « Partager » une fiche voyage : menu natif du téléphone (WhatsApp, SMS, Messenger…), copie du lien sur PC.
// Le lien porte ?src=partage → visible dans « D'où viennent les inscrits » (provenance).
import React, { useState } from 'react';

const fmt = (d) => d ? new Date(d + 'T00:00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

export const lienPartage = (trip) => `${window.location.origin}/voyage/${trip.id}?src=partage${trip.parrain ? `&p=${trip.parrain}` : ''}`;
export const textePartage = (trip, perso = false) => {
  const dates = trip.start_date ? (trip.end_date && trip.end_date !== trip.start_date ? `du ${fmt(trip.start_date)} au ${fmt(trip.end_date)}` : `le ${fmt(trip.start_date)}`) : '';
  const prix = trip.price_from ? `${trip.weekly_pricing ? 'à partir de ' : ''}${trip.price_from} €` : '';
  const corps = `${trip.title}${dates ? `, ${dates}` : ''}${prix ? ` — ${prix}` : ''}`;
  return perso ? `Je pars avec Rhône Alpes Amitié : ${corps}. Ça te dit de venir avec moi ? Regarde :` : `Regarde ce voyage de Rhône Alpes Amitié : ${corps}`;
};

export default function ShareButton({ trip, variant = 'hero' }) {
  const [etat, setEtat] = useState('');
  const perso = variant === 'espace';
  // Iter 907 — compteur de partages (Prospection) : un appui = un partage, peu importe le canal choisi ensuite
  const compter = (canal) => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/partages`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ trip_id: trip.id, type: 'partage', origine: perso ? 'espace' : variant === 'bar' ? 'barre' : 'fiche', canal }) }).catch(() => {});
  const partager = async (e) => {
    e?.stopPropagation();  // le hero ouvre la galerie au clic : pas ici
    const url = lienPartage(trip);
    const text = textePartage(trip, perso);
    if (navigator.share) {
      try { await navigator.share({ title: trip.title, text, url }); compter('natif'); return; } catch (err) { if (err?.name === 'AbortError') return; }
    }
    try { await navigator.clipboard.writeText(`${text}\n${url}`); setEtat('copie'); compter('copie'); }
    catch { window.prompt('Copiez ce lien :', url); compter('copie'); }
    setTimeout(() => setEtat(''), 2500);
  };
  const wa = `https://wa.me/?text=${encodeURIComponent(`${textePartage(trip, perso)}\n${lienPartage(trip)}`)}`;
  // Iter 910 — 🖼️ carte image (story 1080×1920) : partage natif avec le fichier si possible, sinon ouverture pour l'enregistrer
  const [imgBusy, setImgBusy] = useState(false);
  const urlImage = (format) => `${process.env.REACT_APP_BACKEND_URL}/api/trips/${trip.id}/carte-partage.jpg?format=${format}`;
  const partagerImage = async (e) => {
    e?.stopPropagation();
    setImgBusy(true);
    try {
      const blob = await (await fetch(urlImage('story'))).blob();
      const file = new File([blob], `RAAV_${(trip.title || 'voyage').slice(0, 30).replace(/\s+/g, '_')}.jpg`, { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: trip.title, text: `${textePartage(trip, perso)}\n${lienPartage(trip)}` });
        compter('image');
      } else {
        window.open(urlImage('story'), '_blank', 'noopener');
        compter('image');
      }
    } catch (err) { if (err?.name !== 'AbortError') window.open(urlImage('story'), '_blank', 'noopener'); }
    setImgBusy(false);
  };
  const IcoImg = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
  const Ico = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" d="M4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7M16 6l-4-4-4 4M12 2v13" /></svg>;
  if (variant === 'espace') return (
    <div className="space-y-1.5" data-testid={`fiche-partage-${trip.reg_id || trip.id}`} onClick={e => e.stopPropagation()}>
      <div className="flex items-center gap-2">
        <button type="button" onClick={partager}
          className="flex-1 min-h-[44px] inline-flex items-center justify-center gap-2 rounded-xl bg-[#1E3A5F] text-white text-sm font-bold px-3"
          data-testid={`fiche-partage-btn-${trip.reg_id || trip.id}`}>
          <Ico />{etat === 'copie' ? '✅ Lien copié — collez-le à votre proche' : 'Partager ce voyage à un proche'}
        </button>
        <a href={wa} target="_blank" rel="noopener noreferrer" onClick={() => compter('whatsapp')} className="hidden sm:inline-flex min-h-[44px] items-center px-3 rounded-xl bg-[#25D366] text-white text-sm font-bold" data-testid={`fiche-partage-wa-${trip.reg_id || trip.id}`}>WhatsApp</a>
      </div>
      <button type="button" onClick={partagerImage} disabled={imgBusy}
        className="w-full min-h-[40px] inline-flex items-center justify-center gap-2 rounded-xl border border-[#1E3A5F]/30 bg-white text-[#1E3A5F] text-xs font-bold px-3 disabled:opacity-60"
        data-testid={`fiche-partage-image-${trip.reg_id || trip.id}`}>
        <IcoImg />{imgBusy ? 'Préparation de l\'image…' : 'Image à poster en story ou à envoyer'}
      </button>
    </div>
  );
  if (variant === 'bar') return (
    <button type="button" onClick={partager} className="w-12 h-12 rounded-xl bg-[#1E3A5F] text-white flex flex-col items-center justify-center" aria-label="Partager ce voyage" data-testid="trip-share-bar-btn">
      <Ico /><span className="text-[9px] font-bold -mt-0.5">{etat === 'copie' ? 'Copié !' : 'Partager'}</span>
    </button>
  );
  return (
    <div className="flex items-center gap-2" data-testid="trip-share" onClick={e => e.stopPropagation()}>
      <button type="button" onClick={partager}
        className="min-h-[44px] inline-flex items-center gap-2 bg-white/90 hover:bg-white text-[#1E3A5F] px-4 rounded-full text-sm font-bold shadow backdrop-blur-sm transition"
        data-testid="trip-share-btn">
        <Ico />{etat === 'copie' ? '✅ Lien copié !' : 'Partager'}
      </button>
      <a href={wa} target="_blank" rel="noopener noreferrer" onClick={() => compter('whatsapp')} className="hidden sm:inline-flex min-h-[44px] items-center gap-1.5 bg-[#25D366] hover:bg-[#1fb855] text-white px-4 rounded-full text-sm font-bold shadow transition" data-testid="trip-share-whatsapp">
        WhatsApp
      </a>
      <button type="button" onClick={partagerImage} disabled={imgBusy} title="Image à poster en story ou à envoyer"
        className="min-h-[44px] inline-flex items-center gap-1.5 bg-white/90 hover:bg-white text-[#1E3A5F] px-3 rounded-full text-sm font-bold shadow backdrop-blur-sm transition disabled:opacity-60"
        data-testid="trip-share-image">
        <IcoImg /><span className="hidden sm:inline">{imgBusy ? 'Préparation…' : 'Image'}</span>
      </button>
    </div>
  );
}
